<template>
  <div>
    <div class="m-b-20 ovf-hd">
      <div class="fl w-300">
        <el-input placeholder="请输入账号" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    border
    style="width: 100%"
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="编号">
      </el-table-column>
      <el-table-column
      prop="username"
      label="登录账号">
      </el-table-column>
      <el-table-column
      prop="time"
      label="登录时间">
      </el-table-column>
      <el-table-column
      prop="login_ip"
      label="登录ip">
      </el-table-column>
      <el-table-column
      label="操作"
      width="100">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="ipmess(scope.row.id)">IP详细</el-button>
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'business'"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="ip详细" :visible.sync="open_ip" size="tiny" append-to-body width="30%">
      <el-form ref="form" :model="form_place_revoke" label-width="40%" :rules="rules">
        <el-form-item label="ip" :label-width="formLabelWidth">
          <b v-text="ip_detail.ip"></b>
        </el-form-item>
        <el-form-item label="国家" :label-width="formLabelWidth">
          <b v-text="ip_detail.country"></b>
        </el-form-item>
        <el-form-item label="省份" :label-width="formLabelWidth">
          <b v-text="ip_detail.regionName"></b>
        </el-form-item>
        <el-form-item label="城市" :label-width="formLabelWidth">
          <b v-text="ip_detail.city"></b>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="open_ip = false" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15,
        open_ip: false,
        ip_detail: {
          ip: '正在查询中',
          country: '正在查询中',
          regionName: '正在查询中',
          city: '正在查询中'
        }
      }
    },
    methods: {
      abc(data) {
        this.showbtn = true
        console.log(data.links)
      },
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      ipmess(id) {
        this.ip_detail = {
          ip: '正在查询中',
          country: '正在查询中',
          regionName: '正在查询中',
          city: '正在查询中'
        }
        this.open_ip = true
        this.apiGet('admin/files_log/getipmess?id=' + id).then((res) => {
          this.handelResponse(res, (data) => {
            this.ip_detail = data
          })
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiPost('admin/files_log/loginlog', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.logtype = data.type
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('tondun-save')
      },
      editShow() {
        return _g.getHasRule('tondun-update')
      },
      deleteShow() {
        return _g.getHasRule('tondun-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?bb87761a